module.exports = __webpack_public_path__ + "static/media/food-3.d0e83357.png";